import { InstructionTypes } from '../../Constants'
import { Instruction } from './Instruction'

export class ClickInputInstruction extends Instruction {
  constructor ({ name, label, waitForNoLoaders, click }) {
    super({ name, waitForNoLoaders, type: InstructionTypes.ClickInput })
    this.label = label
    this.click = click
  }

  prepareInstruction (id, params) {
    this.id = id
    this.setValue(params)
  }

  setValue (params) {
    if (this.click === undefined) {
      this.setDefaultValue(params)
    }
  }

  setDefaultValue (params) {
    this.click = true
  }

  getParsedInstruction () {
    return {
      ...super.getParsedInstruction(),
      label: this.label,
      click: this.click
    }
  }
}
